import React, { Component } from "react"
import gql from "graphql-tag"

import { graphql } from "@apollo/client/react/hoc"
import { Container, Col, Row, Label, Input, Alert, Button, Table } from "reactstrap"
import Skeleton from "react-loading-skeleton"
import { AllGroups, AllGroupsBasedOnPermission } from "../../Queries"

import withApolloClient from "../../../withApolloClient"
import "./OverviewTab.css"

const UpdatePermissionMutation = gql`
mutation UpdatePermission($input: UpdatePermissionMutationInput!){
    updatePermission(input:$input){
        ok
        errors{
            messages
        }
    }
} `

const PAGE_SIZE = 30

const AllMembers = gql`query AllMembers($cursor: String, $first: Int, $searchTerm: String){
    allMembers(first: $first, after: $cursor, searchTerm: $searchTerm) {
        edges {
            node {
                id
                user{
                    id
                    username
                    firstName
                    lastName
                }
            }
        }
        pageInfo{
            endCursor
            hasNextPage
        }
    }
}`

const PermissionDetailQuery = gql`query permission($id: ID!){
    permission(id: $id) {
        id
        name
        codename
        contentType {
            id
            model
            appLabel
        }
        groupSet {
            edges {
                node {
                    id
                    name
                }
            }
        }
        userSet {
            edges {
                node {
                    id
                    username
                    firstName
                    lastName
                }
            }
        }
    }
  }  
`

class OverviewTab extends Component {
    constructor(props) {
        super(props)
        this.state = {
            error: null,
            loading: false,
            assignedGroups: [],
            assignedUsers: [],
            selectedAvailableGroupIds: [],
            selectedAssignedGroupIds: [],
            selectedAvailableUserIds: [],
            selectedAssignedUserIds: [],
            groupsLoadingMore: false,
            usersLoadingMore: false,
            groupSearchTerm: "",
            userSearchTerm: "",
            disableUpdateBtn: true,
            input: {},
        }
    }

    addSelectedItems = (selectedKey, targetKey, sourceItems, searchKey) => {
        const selectedIds = this.state[selectedKey]
        if (!selectedIds.length) {
            return
        }
        const hadSearch = searchKey ? Boolean(this.state[searchKey]) : false
        const selectedItems = sourceItems.filter((item) => selectedIds.includes(item.value))
        const merged = new Map(this.state[targetKey].map((item) => [item.value, item]))
        selectedItems.forEach((item) => merged.set(item.value, item))
        const nextState = {
            [targetKey]: Array.from(merged.values()),
            [selectedKey]: [],
            disableUpdateBtn: false,
        }
        if (searchKey) {
            nextState[searchKey] = ""
        }
        this.setState(nextState, () => {
            if (!hadSearch) {
                return
            }
            if (searchKey === "groupSearchTerm" && this.props.allGroupsRefetch) {
                this.props.allGroupsRefetch({
                    first: PAGE_SIZE,
                    cursor: null,
                    name_Icontains: null,
                })
            }
            if (searchKey === "userSearchTerm" && this.props.allMembersRefetch) {
                this.props.allMembersRefetch({
                    first: PAGE_SIZE,
                    cursor: null,
                    searchTerm: null,
                })
            }
        })
    };

    removeSelectedItems = (selectedKey, targetKey) => {
        const selectedIds = new Set(this.state[selectedKey])
        if (!selectedIds.size) {
            return
        }
        const updatedItems = this.state[targetKey].filter((item) => !selectedIds.has(item.value))
        this.setState({
            [targetKey]: updatedItems,
            [selectedKey]: [],
            disableUpdateBtn: false,
        })
    };

    removeAllItems = (targetKey, selectedKey) => {
        if (!this.state[targetKey].length) {
            return
        }
        this.setState({
            [targetKey]: [],
            [selectedKey]: [],
            disableUpdateBtn: false,
        })
    };

    loadMoreGroups = () => {
        const { allGroupsFetchMore, allGroups, allGroupsVariables } = this.props
        if (!allGroupsFetchMore || !allGroups || !allGroups.pageInfo || !allGroups.pageInfo.hasNextPage) {
            return
        }
        this.setState({ groupsLoadingMore: true })
        return allGroupsFetchMore({
            query: AllGroups,
            variables: {
                ...allGroupsVariables,
                first: PAGE_SIZE,
                cursor: allGroups.pageInfo.endCursor,
                name_Icontains: this.state.groupSearchTerm || null,
            },
            updateQuery: (previousResult, { fetchMoreResult }) => {
                if (!fetchMoreResult || !fetchMoreResult.allGroups) {
                    return previousResult
                }
                return {
                    allGroups: {
                        edges: [...previousResult.allGroups.edges, ...fetchMoreResult.allGroups.edges],
                        pageInfo: fetchMoreResult.allGroups.pageInfo,
                        __typename: previousResult.allGroups.__typename,
                    },
                }
            },
        }).finally(() => {
            this.setState({ groupsLoadingMore: false })
        })
    };

    loadMoreUsers = () => {
        const { allMembersFetchMore, allMembers, allMembersVariables } = this.props
        if (!allMembersFetchMore || !allMembers || !allMembers.pageInfo || !allMembers.pageInfo.hasNextPage) {
            return
        }
        this.setState({ usersLoadingMore: true })
        return allMembersFetchMore({
            query: AllMembers,
            variables: {
                ...allMembersVariables,
                first: PAGE_SIZE,
                cursor: allMembers.pageInfo.endCursor,
                searchTerm: this.state.userSearchTerm || null,
            },
            updateQuery: (previousResult, { fetchMoreResult }) => {
                if (!fetchMoreResult || !fetchMoreResult.allMembers) {
                    return previousResult
                }
                return {
                    allMembers: {
                        edges: [...previousResult.allMembers.edges, ...fetchMoreResult.allMembers.edges],
                        pageInfo: fetchMoreResult.allMembers.pageInfo,
                        __typename: previousResult.allMembers.__typename,
                    },
                }
            },
        }).finally(() => {
            this.setState({ usersLoadingMore: false })
        })
    };

    handleGroupSearchChange = (event) => {
        const value = event.target.value
        this.setState({ groupSearchTerm: value })
        if (this.props.allGroupsRefetch) {
            this.props.allGroupsRefetch({
                first: PAGE_SIZE,
                cursor: null,
                name_Icontains: value || null,
            })
        }
    };

    handleUserSearchChange = (event) => {
        const value = event.target.value
        this.setState({ userSearchTerm: value })
        if (this.props.allMembersRefetch) {
            this.props.allMembersRefetch({
                first: PAGE_SIZE,
                cursor: null,
                searchTerm: value || null,
            })
        }
    };

    updatePermission = () => {
        if (this.props.permission && this.props.permission.id) {
            this.setState({ loading: true })
            let input = this.state.input
            input["permissionId"] = this.props.permission && this.props.permission.id
            if (this.state.assignedGroups)
                input["groups"] = this.state.assignedGroups.map(item => { return item.value })
            if (this.state.assignedUsers)
                input["users"] = this.state.assignedUsers.map(item => { return item.value })
            this.props.apolloClient.mutate({
                mutation: UpdatePermissionMutation,
                variables: { input },
            }).then((result) => {
                if (result && result.data && result.data.updatePermission && result.data.updatePermission.ok) {
                    this.props.refetchQuery()
                    this.props.refetchPermissionBasedGroupQuery()
                    this.setState({ input: {}, loading: false, error: null })
                } else if (result.data.updatePermission && result.data.updatePermission.errors) {
                    this.setState({ loading: false, error: String(result.data.updatePermission.errors[0].messages) })
                } else {
                    this.setState({ loading: false, error: "An error has occurred. Please check your input or contact admin." })
                }
            }).catch(() => {
                this.setState({ loading: false, error: "An error has occurred. Please contact admin." })
            })
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.permission !== prevProps.permission) {
            let assignedGroupsArr = []
            let assignedUsersArr = []
            if (this.props.permission && this.props.permission.groupSet && this.props.permission.groupSet.edges && this.props.permission.groupSet.edges.length > 0) {
                this.props.permission.groupSet.edges.map((item) =>
                    assignedGroupsArr.push({ value: item.node.id, label: item.node.name })
                )
            }
            if (this.props.permission && this.props.permission.userSet && this.props.permission.userSet.edges && this.props.permission.userSet.edges.length > 0) {
                this.props.permission.userSet.edges.map((item) =>
                    assignedUsersArr.push({
                        value: item.node.id,
                        label: item.node.firstName ? item.node.firstName + " " + item.node.lastName : item.node.username,
                    })
                )
            }
            this.setState({
                assignedGroups: assignedGroupsArr,
                assignedUsers: assignedUsersArr,
                selectedAvailableGroupIds: [],
                selectedAssignedGroupIds: [],
                selectedAvailableUserIds: [],
                selectedAssignedUserIds: [],
            })
            return
        }
        this.maybeLoadMoreGroups(prevProps, prevState)
        this.maybeLoadMoreUsers(prevProps, prevState)
    }

    getAvailableGroups = () => {
        const assignedGroupsIds = this.state.assignedGroups.map((group) => group.value)
        return (this.props.allGroups?.edges || [])
            .filter((item) => !assignedGroupsIds.some((groupId) => groupId === item.node.id))
            .map((item) => ({ value: item.node.id, label: item.node.name }))
    };

    getAvailableUsers = () => {
        const assignedUsersIds = this.state.assignedUsers.map((group) => group.value)
        return (this.props.allMembers?.edges || [])
            .filter((item) => !assignedUsersIds.some((memberId) => memberId === item.node.user.id))
            .map((item) => ({
                value: item.node.user.id,
                label: item.node.user.firstName ? item.node.user.firstName + " " + item.node.user.lastName : item.node.user.username,
            }))
    };

    maybeLoadMoreGroups = (prevProps, prevState) => {
        const groupsHasNextPage = this.props.allGroups?.pageInfo?.hasNextPage || false
        if (!groupsHasNextPage || this.state.groupsLoadingMore) {
            return
        }
        const availableGroupsAll = this.getAvailableGroups()
        if (availableGroupsAll.length !== 0) {
            return
        }
        const groupsAssignedChanged = prevState.assignedGroups.length !== this.state.assignedGroups.length
        const groupEdgesChanged = (prevProps.allGroups?.edges || []).length !== (this.props.allGroups?.edges || []).length
        if (groupsAssignedChanged || groupEdgesChanged) {
            this.loadMoreGroups()
        }
    };

    maybeLoadMoreUsers = (prevProps, prevState) => {
        const usersHasNextPage = this.props.allMembers?.pageInfo?.hasNextPage || false
        if (!usersHasNextPage || this.state.usersLoadingMore) {
            return
        }
        const availableUsersAll = this.getAvailableUsers()
        if (availableUsersAll.length !== 0) {
            return
        }
        const usersAssignedChanged = prevState.assignedUsers.length !== this.state.assignedUsers.length
        const userEdgesChanged = (prevProps.allMembers?.edges || []).length !== (this.props.allMembers?.edges || []).length
        if (usersAssignedChanged || userEdgesChanged) {
            this.loadMoreUsers()
        }
    };

    getUsersGroupsMap = () => {
        const usersGroupsMap = {}
        this.props.permissionBasedGroups?.edges?.forEach((group) => {
            const userEdges = group.node.userSet?.edges || []
            userEdges.forEach((user) => {
                const userName = user.node.username
                if (!usersGroupsMap[userName]) {
                    usersGroupsMap[userName] = []
                }
                usersGroupsMap[userName].push(group.node.name)
            })
        })
        return usersGroupsMap
    };

    renderTableRows = () => {
        const usersGroupsMap = this.getUsersGroupsMap()
        const userKeys = Object.keys(usersGroupsMap)
        if (!userKeys.length) {
            return (
                <tr>
                    <td colSpan="2" className="overview-no-data">No data found.</td>
                </tr>
            )
        }
        return userKeys.map((userName, index) => (
            <tr key={index}>
                <td>{userName}</td>
                <td>
                    {usersGroupsMap[userName].map((groupName, groupIndex) => (
                        <span key={groupIndex}>{groupName}{groupIndex !== usersGroupsMap[userName].length - 1 ? ", " : ""}</span>
                    ))}
                </td>
            </tr>
        ))
    };

    render() {
        const availableGroupsAll = this.getAvailableGroups()
        const availableUsersAll = this.getAvailableUsers()
        const groupsHasNextPage = this.props.allGroups?.pageInfo?.hasNextPage || false
        const usersHasNextPage = this.props.allMembers?.pageInfo?.hasNextPage || false
        const isLoading = this.props.loading || this.state.loading || !this.props.permission
        const usersGroupsMap = this.getUsersGroupsMap()

        return (
            <Container fluid className="permission-overview">
                {isLoading ? (
                    <div className="overview-page-skeleton">
                        <Skeleton count={6} height={24} />
                    </div>
                ) : <>
                    {this.state.error && <Row><Col xs={12}><Alert color="danger">{this.state.error}</Alert></Col></Row>}
                    <Row className="overview-info-row">
                        <Col xs={12} className="overview-info-card" style={{ borderTopLeftRadius: "0px" }}>
                            <Row>
                                <Col md={4}>
                                    <Label className="overview-info-label">Name</Label>
                                    <Input disabled className="box-object-property-input" value={this.props.permission.name ? this.props.permission.name : "--"} />
                                </Col>
                                <Col md={4}>
                                    <Label className="overview-info-label">Code Name</Label>
                                    <Input disabled className="box-object-property-input" value={this.props.permission.codename ? this.props.permission.codename : "--"} />
                                </Col>
                                <Col md={4}>
                                    <Label className="overview-info-label">Content Type</Label>
                                    <Input disabled className="box-object-property-input" value={(this.props.permission.contentType ? this.props.permission.contentType.appLabel + " | " + this.props.permission.contentType.model : "--")} />
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                    <Row className="overview-section-row overview-dual-section">
                        <Col lg={6} className="overview-section-col">
                            <Row className="overview-section-row overview-tight-gap">
                                <Col md={5} className="overview-card">
                                    <div className="overview-card-header">
                                        <span>Available Groups</span>
                                        <span className="overview-count">{availableGroupsAll.length}</span>
                                    </div>
                                    <div className="overview-search">
                                        <Input
                                            className="overview-search-input"
                                            name="groupSearchTerm"
                                            id="groupSearchTerm"
                                            value={this.state.groupSearchTerm}
                                            onChange={this.handleGroupSearchChange}
                                            placeholder="Search groups..."
                                        />
                                    </div>
                                    <div className="overview-list">
                                        {this.props.allGroupsLoading ? (
                                            <div className="overview-list-skeleton">
                                                <Skeleton count={8} height={18} />
                                            </div>
                                        ) : (
                                            availableGroupsAll.length === 0 ? <div className="overview-no-data">No groups available.</div> :
                                                <Input
                                                    type="select"
                                                    multiple
                                                    className="overview-select"
                                                    value={this.state.selectedAvailableGroupIds}
                                                    onChange={(event) => {
                                                        const selected = Array.from(event.target.selectedOptions).map((option) => option.value)
                                                        this.setState({ selectedAvailableGroupIds: selected })
                                                    }}
                                                >
                                                    {availableGroupsAll.map((item) => (
                                                        <option key={item.value} value={item.value}>{item.label}</option>
                                                    ))}
                                                </Input>
                                        )}
                                    </div>
                                    {this.state.groupsLoadingMore && (
                                        <div className="overview-list-skeleton">
                                            <Skeleton count={4} height={18} />
                                        </div>
                                    )}
                                    {groupsHasNextPage && (
                                        <div className="overview-load-more">
                                            <span
                                                className={`overview-load-link ${(!groupsHasNextPage || this.state.groupsLoadingMore) ? "is-disabled" : ""}`}
                                                role="button"
                                                tabIndex={0}
                                                onClick={() => groupsHasNextPage && !this.state.groupsLoadingMore && this.loadMoreGroups()}
                                            >
                                                Load more
                                            </span>
                                        </div>
                                    )}
                                </Col>
                                <Col md={2} className="overview-transfer">
                                    <Button
                                        onClick={() => this.addSelectedItems("selectedAvailableGroupIds", "assignedGroups", availableGroupsAll, "groupSearchTerm")}
                                        className="transfer-btn"
                                        disabled={!this.state.selectedAvailableGroupIds.length}
                                    >
                                        <i className="fa fa-chevron-right" aria-hidden="true"></i>
                                    </Button>
                                    <Button
                                        onClick={() => this.removeSelectedItems("selectedAssignedGroupIds", "assignedGroups")}
                                        className="transfer-btn"
                                        disabled={!this.state.selectedAssignedGroupIds.length}
                                    >
                                        <i className="fa fa-chevron-left" aria-hidden="true"></i>
                                    </Button>
                                </Col>
                                <Col md={5} className="overview-card">
                                    <div className="overview-card-header">
                                        <span>Assigned Groups</span>
                                        <span className="overview-count">{this.state.assignedGroups.length}</span>
                                    </div>
                                    <div className="overview-list">
                                        {this.props.allGroupsLoading ? (
                                            <div className="overview-list-skeleton">
                                                <Skeleton count={8} height={18} />
                                            </div>
                                        ) : (
                                            this.state.assignedGroups.length === 0 ? <div className="overview-no-data">No groups assigned.</div> :
                                                <Input
                                                    type="select"
                                                    multiple
                                                    className="overview-select"
                                                    value={this.state.selectedAssignedGroupIds}
                                                    onChange={(event) => {
                                                        const selected = Array.from(event.target.selectedOptions).map((option) => option.value)
                                                        this.setState({ selectedAssignedGroupIds: selected })
                                                    }}
                                                >
                                                    {this.state.assignedGroups.map((item) => (
                                                        <option key={item.value} value={item.value}>{item.label}</option>
                                                    ))}
                                                </Input>
                                        )}
                                    </div>
                                </Col>
                            </Row>
                            <Row className="overview-bulk-row overview-tight-gap">
                                <Col md={5} className="overview-bulk-col"></Col>
                                <Col md={2}></Col>
                                <Col md={5} className="overview-bulk-col">
                                    <span
                                        className={`overview-bulk-link ${!this.state.assignedGroups.length ? "is-disabled" : ""}`}
                                        role="button"
                                        tabIndex={0}
                                        onClick={() => {
                                            if (this.state.assignedGroups.length) {
                                                this.removeAllItems("assignedGroups", "selectedAssignedGroupIds")
                                            }
                                        }}
                                    >
                                        <i className="fa fa-chevron-circle-left" aria-hidden="true"></i> Remove All
                                    </span>
                                </Col>
                            </Row>
                        </Col>
                        <Col lg={6} className="overview-section-col">
                            <Row className="overview-section-row">
                                <Col md={5} className="overview-card">
                                    <div className="overview-card-header">
                                        <span>All Users</span>
                                        <span className="overview-count">{availableUsersAll.length}</span>
                                    </div>
                                    <div className="overview-search">
                                        <Input
                                            className="overview-search-input"
                                            name="userSearchTerm"
                                            id="userSearchTerm"
                                            value={this.state.userSearchTerm}
                                            onChange={this.handleUserSearchChange}
                                            placeholder="Search users..."
                                        />
                                    </div>
                                    <div className="overview-list">
                                        {this.props.allMembersLoading ? (
                                            <div className="overview-list-skeleton">
                                                <Skeleton count={8} height={18} />
                                            </div>
                                        ) : (
                                            availableUsersAll.length === 0 ? <div className="overview-no-data">No users available.</div> :
                                                <Input
                                                    type="select"
                                                    multiple
                                                    className="overview-select"
                                                    value={this.state.selectedAvailableUserIds}
                                                    onChange={(event) => {
                                                        const selected = Array.from(event.target.selectedOptions).map((option) => option.value)
                                                        this.setState({ selectedAvailableUserIds: selected })
                                                    }}
                                                >
                                                    {availableUsersAll.map((item) => (
                                                        <option key={item.value} value={item.value}>{item.label}</option>
                                                    ))}
                                                </Input>
                                        )}
                                    </div>
                                    {this.state.usersLoadingMore && (
                                        <div className="overview-list-skeleton">
                                            <Skeleton count={4} height={18} />
                                        </div>
                                    )}
                                    {usersHasNextPage && (
                                        <div className="overview-load-more">
                                            <span
                                                className={`overview-load-link ${(!usersHasNextPage || this.state.usersLoadingMore) ? "is-disabled" : ""}`}
                                                role="button"
                                                tabIndex={0}
                                                onClick={() => usersHasNextPage && !this.state.usersLoadingMore && this.loadMoreUsers()}
                                            >
                                                Load more
                                            </span>
                                        </div>
                                    )}
                                </Col>
                                <Col md={2} className="overview-transfer">
                                    <Button
                                        onClick={() => this.addSelectedItems("selectedAvailableUserIds", "assignedUsers", availableUsersAll, "userSearchTerm")}
                                        className="transfer-btn"
                                        disabled={!this.state.selectedAvailableUserIds.length}
                                    >
                                        <i className="fa fa-chevron-right" aria-hidden="true"></i>
                                    </Button>
                                    <Button
                                        onClick={() => this.removeSelectedItems("selectedAssignedUserIds", "assignedUsers")}
                                        className="transfer-btn"
                                        disabled={!this.state.selectedAssignedUserIds.length}
                                    >
                                        <i className="fa fa-chevron-left" aria-hidden="true"></i>
                                    </Button>
                                </Col>
                                <Col md={5} className="overview-card">
                                    <div className="overview-card-header">
                                        <span>Assigned Users</span>
                                        <span className="overview-count">{this.state.assignedUsers.length}</span>
                                    </div>
                                    <div className="overview-list">
                                        {this.props.allMembersLoading ? (
                                            <div className="overview-list-loading">
                                                <Skeleton count={8} height={18} />
                                            </div>
                                        ) : (
                                            this.state.assignedUsers.length === 0 ? <div className="overview-no-data">No users assigned.</div> :
                                                <Input
                                                    type="select"
                                                    multiple
                                                    className="overview-select"
                                                    value={this.state.selectedAssignedUserIds}
                                                    onChange={(event) => {
                                                        const selected = Array.from(event.target.selectedOptions).map((option) => option.value)
                                                        this.setState({ selectedAssignedUserIds: selected })
                                                    }}
                                                >
                                                    {this.state.assignedUsers.map((item) => (
                                                        <option key={item.value} value={item.value}>{item.label}</option>
                                                    ))}
                                                </Input>
                                        )}
                                    </div>
                                </Col>
                            </Row>
                            <Row className="overview-bulk-row overview-tight-gap">
                                <Col md={5} className="overview-bulk-col"></Col>
                                <Col md={2}></Col>
                                <Col md={5} className="overview-bulk-col">
                                    <span
                                        className={`overview-bulk-link ${!this.state.assignedUsers.length ? "is-disabled" : ""}`}
                                        role="button"
                                        tabIndex={0}
                                        onClick={() => {
                                            if (this.state.assignedUsers.length) {
                                                this.removeAllItems("assignedUsers", "selectedAssignedUserIds")
                                            }
                                        }}
                                    >
                                        <i className="fa fa-chevron-circle-left" aria-hidden="true"></i> Remove All
                                    </span>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                    <Row className="overview-section-row">
                        <Col xs={12} className="overview-card permission-table-card">
                            <div className="overview-card-header">
                                <span>Users by Group</span>
                                <span className="overview-count">{Object.keys(usersGroupsMap).length}</span>
                            </div>
                            <div className="overview-list permission-table-list">
                                <Table>
                                    <thead>
                                        <tr>
                                            <th>User</th>
                                            <th>Groups</th>
                                        </tr>
                                    </thead>
                                    <tbody>{this.renderTableRows()}</tbody>
                                </Table>
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col className="d-flex justify-content-end pr-5"><Button onClick={this.updatePermission} className="overview-primary-btn" disabled={this.state.disableUpdateBtn}>UPDATE</Button></Col>
                    </Row>
                </>}
            </Container>
        )
    }
}


//-----------------------------------
export default graphql(PermissionDetailQuery, {
    options: ({ permissionId }) => ({
        variables: { id: permissionId },
        fetchPolicy: "network-only",
        notifyOnNetworkStatusChange: true,
    }),
    props: ({ data: { permission, loading, refetch, variables } }) => ({
        permission,
        loading,
        variables,
        refetchQuery: () => {
            return refetch({
                query: PermissionDetailQuery,
                variables: {
                    ...variables,
                },
                updateQuery: (previousResult, { fetchMoreResult }) => {
                    return { permission: fetchMoreResult.permission }
                },
            })
        },
    }),
})(
    graphql(AllGroupsBasedOnPermission, {
        options: ({ permissionId }) => ({
            variables: { permissionId },
            fetchPolicy: "network-only",
            notifyOnNetworkStatusChange: true,
        }),
        props: ({ data: { permissionBasedGroups, loading, refetch, variables } }) => ({
            permissionBasedGroups,
            permissionBasedGroupsLoading: loading,
            variables,
            refetchPermissionBasedGroupQuery: () => {
                return refetch({
                    query: AllGroupsBasedOnPermission,
                    variables: {
                        ...variables,
                    },
                    updateQuery: (previousResult, { fetchMoreResult }) => {
                        return { permissionBasedGroups: fetchMoreResult.permissionBasedGroups }
                    },
                })
            },
        }),
    })(
        graphql(AllGroups, {
            options: () => ({
                fetchPolicy: "network-only",
                notifyOnNetworkStatusChange: true,
                variables: { first: PAGE_SIZE },
            }),
            props: ({ data }) => ({
                allGroups: data.allGroups,
                allGroupsLoading: data.loading,
                allGroupsRefetch: data.refetch,
                allGroupsFetchMore: data.fetchMore,
                allGroupsVariables: data.variables,
            }),
        })(
            graphql(AllMembers, {
                options: () => ({
                    fetchPolicy: "network-only",
                    notifyOnNetworkStatusChange: true,
                    variables: { first: PAGE_SIZE },
                }),
                props: ({ data }) => ({
                    allMembers: data.allMembers,
                    allMembersLoading: data.loading,
                    allMembersRefetch: data.refetch,
                    allMembersFetchMore: data.fetchMore,
                    allMembersVariables: data.variables,
                }),
            })(
                withApolloClient(OverviewTab)
            )
        )
    )
);
